import { Effect, Actions } from "@ngrx/effects";
import { Injectable } from "@angular/core";
import { CronosActions, CronosListTeamsAction, CronosListProjectsAction, CronosReorderAction, CronosSaveTaskAction, CronosSaveCommentAction, CronosSaveFileAction, CronosRemoveTaskAction, CronosSaveProjectAction } from "../action/CronosActions";
import { CronosService } from "../../services/CronosService";
import { CronosActionTypes } from "../action";
import { Observable } from "rxjs";

@Injectable()
export class CronosEffects {

    constructor(
        private actions: Actions<CronosActions>,
        private cronosService: CronosService
    ) {

    }

    @Effect()
    teamsList$ = this.actions.ofType(CronosActionTypes.LIST_TEAMS)
        .map((action: CronosListTeamsAction) => action)
        .switchMap(action => this.cronosService.listTeams(action.payload.clientId)
            .map(response => ({ type: CronosActionTypes.LIST_TEAMS_SUCCESS, teams: response }))
            .catch(error => Observable.of({ type: CronosActionTypes.LIST_TEAMS_ERROR, errorPayload: { errorStatus: error.status } }))
        );
    
    @Effect()
    projectsList$ = this.actions.ofType(CronosActionTypes.LIST_PROJECTS)
        .map((action: CronosListProjectsAction) => action)
        .switchMap(action => this.cronosService.listProjects(action.payload.userId)
            .map(response => ({ type: CronosActionTypes.LIST_PROJECTS_SUCCESS, projects: response }))
            .catch(error => Observable.of({ type: CronosActionTypes.LIST_PROJECTS_ERROR, errorPayload: { errorStatus: error.status } }))
        );
    
    @Effect()
    reorder$ = this.actions.ofType(CronosActionTypes.REORDER)
        .map((action: CronosReorderAction) => action)
        .switchMap(action => this.cronosService.saveList(action.payload.model)
            .map(response => ({ type: CronosActionTypes.REORDER_SUCCESS, reorderData: response, actionProjectId: action.payload.projectId }))
            .catch(error => Observable.of({ type: CronosActionTypes.REORDER_ERROR, errorPayload: { errorStatus: error.status } }))
        );
    
    @Effect()
    saveTask$ = this.actions.ofType(CronosActionTypes.SAVE_TASK)
        .map((action: CronosSaveTaskAction) => action)
        .switchMap(action => this.cronosService.saveTask(action.payload.model)
            .map(response => ({ type: CronosActionTypes.SAVE_TASK_SUCCESS, savedTaskData: response, actionProjectId: action.payload.projectId, actionListId: action.payload.listId }))
            .catch(error => Observable.of({ type: CronosActionTypes.SAVE_TASK_ERROR, errorPayload: { errorStatus: error.status } }))
        );
    
    @Effect()
    removeTask$ = this.actions.ofType(CronosActionTypes.REMOVE_TASK)
        .map((action: CronosRemoveTaskAction) => action)
        .switchMap(action => this.cronosService.removeTask(action.payload.model)
            .map(response => ({ type: CronosActionTypes.REMOVE_TASK_SUCCESS, actionProjectId: action.payload.projectId, actionListId: action.payload.listId }))
            .catch(error => Observable.of({ type: CronosActionTypes.REMOVE_TASK_ERROR, errorPayload: { errorStatus: error.status } }))
        );
    
    @Effect()
    saveComment$ = this.actions.ofType(CronosActionTypes.SAVE_COMMENT)
        .map((action: CronosSaveCommentAction) => action)
        .switchMap(action => this.cronosService.saveComment(action.payload.model)
            .map(response => ({ type: CronosActionTypes.SAVE_COMMENT_SUCCESS, savedCommentData: response, actionProjectId: action.payload.projectId, actionListId: action.payload.listId, actionTaskId: action.payload.taskId }))
            .catch(error => Observable.of({ type: CronosActionTypes.SAVE_COMMENT_ERROR, errorPayload: { errorStatus: error.status } }))
        );
    
    @Effect()
    saveFile$ = this.actions.ofType(CronosActionTypes.SAVE_FILE)
        .map((action: CronosSaveFileAction) => action)
        .switchMap(action => this.cronosService.saveFile(action.payload.file, action.payload.model)
            .map(response => ({ type: CronosActionTypes.SAVE_FILE_SUCCESS, savedFileData: response, actionProjectId: action.payload.projectId, actionListId: action.payload.listId, actionTaskId: action.payload.taskId }))
            .catch(error => Observable.of({ type: CronosActionTypes.SAVE_FILE_ERROR, errorPayload: { errorStatus: error.status } }))
        );
    
    @Effect()
    saveProject$ = this.actions.ofType(CronosActionTypes.SAVE_PROJECT)
        .map((action: CronosSaveProjectAction) => action)
        .switchMap(action => this.cronosService.saveProject(action.payload.model)
            .map(response => ({ type: CronosActionTypes.SAVE_PROJECT_SUCCESS, savedProjectData: response }))
            .catch(error => Observable.of({ type: CronosActionTypes.SAVE_PROJECT_ERROR, errorPayload: { errorStatus: error.status } }))
        );

}


// WEBPACK FOOTER //
// ./src/store/effects/CronosEffects.ts